var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8157 9.68381C17.8157 9.00034 17.7591 8.50159 17.6366 7.98438H9.67285V11.0692H14.3474C14.2532 11.8358 13.7443 12.9903 12.6133 13.7661L12.5974 13.8694L15.1155 15.7811L15.2899 15.7981C16.8921 14.348 17.8157 12.2145 17.8157 9.68381Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6721 17.8106C11.9622 17.8106 13.8848 17.0717 15.2891 15.7971L12.6125 13.7651C11.8963 14.2546 10.935 14.5964 9.6721 14.5964C7.42907 14.5964 5.52532 13.1463 4.84668 11.1421L4.74721 11.1504L2.12897 13.1362L2.09473 13.2294C3.48955 15.9449 6.35462 17.8106 9.6721 17.8106Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84616 11.1439C4.66709 10.6267 4.56346 10.0725 4.56346 9.49988C4.56346 8.92721 4.66709 8.37306 4.83674 7.85585L4.83199 7.7457L2.18093 5.72803L2.09419 5.76846C1.51932 6.89528 1.18945 8.16065 1.18945 9.49988C1.18945 10.8391 1.51932 12.1044 2.09419 13.2312L4.84616 11.1439Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67214 4.4036C11.2649 4.4036 12.3393 5.07783 12.9519 5.64127L15.3457 3.3507C13.8755 2.01147 11.9623 1.18945 9.67214 1.18945C6.35465 1.18945 3.48956 3.05513 2.09473 5.77053L4.83728 7.85792C5.52534 5.85368 7.4291 4.4036 9.67214 4.4036Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.854bad3779407c4a5ad4e03cbad486b8.svg";
export { ForwardRef as ReactComponent };